import { EmployeeDetailsData } from "../types/employee-details";

export const mockEmployeeDetailsData: EmployeeDetailsData = {
  profile: {
    id: 1,
    name: "Nigel Tavaguta",
    position: "Software Developer",
    pScore: 208,
  },
  heatmapData: [
    {
      month: "Apr",
      days: [
        [2, 3, 3, 1, 0],
        [2, 3, 1, 0, 2],
        [3, 1, 1, 2, 3],
        [2, 0, 1, 0, 2],
      ],
    },
    {
      month: "May",
      days: [
        [2, 3, 1, 0, 3],
        [2, 1, 3, 2, 1],
        [1, 3, 2, 1, 2],
        [2, 1, 3, 2, 2],
      ],
    },
    {
      month: "Jun",
      days: [
        [2, 3, 3, 1, 0],
        [2, 3, 1, 0, 2],
        [3, 1, 1, 2, 3],
        [2, 0, 1, 0, 2],
      ],
    },
    {
      month: "Jul",
      days: [
        [2, 1, 2, 3, 1],
        [2, 2, 4, 3, 3],
        [1, 2, 1, 4, 2],
        [1, 3, 2, 3, 2],
      ],
    },
    {
      month: "Aug",
      days: [
        [1, 2, 0, 1, 2],
        [1, 2, 1, 3, 3],
        [3, 2, 1, 2, 2],
        [0, 1, 3, 2, 1],
      ],
    },
    {
      month: "Sep",
      days: [
        [2, 1, 0, 2, 1],
        [1, 2, 0, 1, 2],
        [2, 2, 1, 2, 2],
        [2, 3, 1, 0, 2],
      ],
    },
    {
      month: "Oct",
      days: [
        [1, 2, 0, 2, 1],
        [3, 1, 2, 2, 1],
        [1, 2, 1, 2, 2],
        [1, 2, 1, 0, 2],
      ],
    },
    {
      month: "Nov",
      days: [
        [2, 1, 0, 2, 1],
        [2, 1, 2, 3, 2],
        [1, 2, 1, 2, 1],
        [2, 1, 1, 0, 2],
      ],
    },
    {
      month: "Dec",
      days: [
        [3, 1, 0, 0, 2],
        [0, 2, 1, 3, 1],
        [2, 1, 2, 1, 2],
        [2, 1, 0, 2, 1],
      ],
    },
  ],
  punctualityData: [
    { month: "Jan", value: 180, highlight: false },
    { month: "Feb", value: 150, highlight: false },
    { month: "Mar", value: 200, highlight: false },
    { month: "Apr", value: 160, highlight: false },
    { month: "May", value: 190, highlight: false },
    { month: "Jun", value: 220, highlight: false },
    { month: "Jul", value: 240, highlight: false },
    { month: "Aug", value: 260, highlight: false },
    { month: "Sep", value: 280, highlight: true },
    { month: "Oct", value: 180, highlight: true },
    { month: "Nov", value: 300, highlight: true },
    { month: "Dec", value: 270, highlight: true },
  ],
  onTimeRatio: {
    onTime: 60,
    late: 25,
    didNotCome: 15,
  },
  trendAlert: {
    value: "-10MINS/DAY",
    message:
      "Your punctuality trend is dropping. Arrive early by 10 minutes for 6 days to get this arrival back on track",
  },
};